import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from 'redux-state/store';

interface VendorRoutesProps {
  children: React.ReactNode;
}

const VendorRoutes = ({ children }: VendorRoutesProps) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (user?.role !== 'vendor') {
    return (
      <Navigate to="/pages/errors/404" state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export default VendorRoutes;
